import React from 'react'
import Navbar from '../inc/Navbar'
import Table from 'react-bootstrap/Table';
import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";

function Visiting() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
             <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Visiting Hours <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="darkgoldenrod" />

            <br />
            <div className="container">
                <div className='welcometext'>
                    <h1 className="card-title mb-0"><b>Visiting Hours</b></h1>
                    <div className="col-md-3">
                        <hr style={{ color: "#1D4D93" }} />
                    </div>
                </div>
            </div>
            <div className='visitingtime'>
                <br />
                <div className="album py-1">
                    <div className="container">

                        <Table striped bordered hover variant="light">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Person</th>
                                    <th>Timing</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>	Principal ( With prior appointment )</td>
                                    <td>Monday, Wednesday & Friday ( 11:30 am - 1:30 pm )</td>

                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Vice Principal ( With prior appointment )</td>
                                    <td>Tuesday & Thursday ( 11:00 am - 2:00 pm )</td>

                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td >Headmistress ( Primary )</td>
                                    <td>Monday to Friday

                                        ( 10:00 am - 11:00 am )</td>

                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td >Headmistress ( Secondary )</td>
                                    <td>Monday to Friday ( 3:00 pm - 4:00 pm )	</td>

                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td >HODs & Coordinators</td>
                                    <td>Monday to Friday ( 3:00 pm - 4:00 pm )</td>

                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td >	Accounts Office</td>
                                    <td>Monday to Friday ( 9:00 am - 3:00 pm )	</td>

                                </tr>


                                <tr>


                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
                 <div className='welcometext'>
                <div className="album py-2">
                    <div className="container">
                        <h6 className='mb-2'>ALL COMMUNICATIONS TO BE MADE THROUGH THE SCHOOL OFFICE

                        </h6>
                        <h6>FOR PRIOR APPOINTMENT CONTACT: 7407097799 / 7407015551 /  8001110006</h6>
                    </div>
                </div>
                </div>
                <br />
            </div>

        </div>
    )
}

export default Visiting